/* eslint import/no-unresolved: 0 */
/* eslint import/no-webpack-loader-syntax: 0 */

import deployTemplate from 'ngtemplate-loader?relativeTo=/app/!../../views/modals/deploy.html';
import marketingTemplate from 'ngtemplate-loader?relativeTo=/app/!../../views/modals/marketing-card.html';
import removeDeviceTemplate from 'ngtemplate-loader?relativeTo=/app/!../../views/modals/remove-device.html';
import lockDeviceTemplate from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/device/lock-device/lock-device.html';
import unlockDeviceTemplate from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/device/unlock-device/unlock-device.html';
import confirmTemplate from 'ngtemplate-loader?relativeTo=/app/!../../views/modals/subscription-confirmation.html';
import oneClickPaymentTemplate from 'ngtemplate-loader?relativeTo=/app/!../../views/modals/one-click-payment.html';
import ocpComparisonTemplate from 'ngtemplate-loader?relativeTo=/app/!../../views/modals/ocp-comparison.html';
import activationTemplate from 'ngtemplate-loader?relativeTo=/app/!../../views/modals/activation-confirmation.html';
import cropImage from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/my-account/crop-image/crop-image.html';
import changeLanguage from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/change-lang/change-lang.html';
import changeEmail from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/my-account/change-email/change-email-modal.html';
import deleteAccountConfirmation from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/my-account/delete-account-confirmation/delete-account-confirmation.html';
import passwordConfirmation from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/my-account/password-confirmation/password-confirmation.html';
import getReport from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/my-account/get-report/get-report.html';
import welcomeModalTemplate from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/welcome-modal/welcome-modal.html';
import welcomeModalSpotlightTemplate from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/welcome-modal-spotlight/welcome-modal-spotlight.html';
import Timers from 'common/services/util/-RFC.Timers';
import eventManager from 'common/services/-RFC.eventManager';
import languageSwitcher from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/language-switcher/language-switcher.html';
import productCard from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/store-product-card/product-card.html';
import addPaymentTemplate from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/add-payment/add-payment.html';
import paymentCartTemplate from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/payment-cart/payment-cart.html';
import trialCard from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/store-trial-card/trial-card.html';
import gdprReportTemplate from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/gdpr-report/gdpr-report.html';
import confirmLogin from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/confirm-login/confirm-login.html';
import threatsLandscape from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/threats-landscape/threats-landscape.html';
import coinbaseAccount from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/coinbase-account/coinbase-account.html';
// DWM
import dwmBankAccounts from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/dwm/bank-accounts/bank-accounts.html';
import dwmCreditCards from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/dwm/credit-cards/credit-cards.html';
import dwmAddresses from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/dwm/addresses/addresses.html';
import dwmPhoneNumbers from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/dwm/phone-numbers/phone-numbers.html';
import dwmEmails from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/dwm/emails/emails.html';
import dwmMothersName from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/dwm/mothers-name/mothers-name.html';
import dwmDriversLicense from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/dwm/drivers-license/drivers-license.html';
import dwmInsuranceCards from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/dwm/insurance-cards/insurance-cards.html';
import dwmGamerTags from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/dwm/gamer-tags/gamer-tags.html';
import dwmNotifications from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/dwm/notifications/notifications.html';
import dwmUpsell from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/dwm/dwm-upsell/dwm-upsell.html';
import dwmToggleMonitoring from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/dwm/toggle-monitoring/toggle-monitoring.html';
// Trial modal
import trialModalTemplate from 'ngtemplate-loader?relativeTo=/app/!../controllers/modals/trial-modal/trial-modal.html';

/**
 * Modal controller
 */
angular.module('modals')
    .service('Modals', () => (
        {

            // 'language': {
            //     templatePath: languageTemplate,
            //     controller: 'ChangeLanguage'
            // },
            activate: {
                templatePath: marketingTemplate,
                controller: 'MarketingCard',
            },
            buy: {
                templatePath: productCard,
                controller: 'ProductCard',
            },
            'remove-device': {
                templatePath: removeDeviceTemplate,
                controller: 'RemoveDevice',
            },
            deploy: {
                templatePath: deployTemplate,
                controller: 'Deploy',
            },
            confirm: {
                templatePath: confirmTemplate,
                controller: 'SubscriptionConfirmation',
            },
            'one-click-payment': {
                templatePath: oneClickPaymentTemplate,
                controller: 'OneClickPayment',
            },
            'lock-device': {
                templatePath: lockDeviceTemplate,
                controller: 'LockDevice',
            },
            'unlock-device': {
                templatePath: unlockDeviceTemplate,
                controller: 'UnlockDevice',
            },
            'activation-confirmation': {
                templatePath: activationTemplate,
                controller: 'ActivationConfirmation',
            },
            'crop-image': {
                templatePath: cropImage,
                controller: 'CropImage',
            },
            'change-lang': {
                templatePath: changeLanguage,
                controller: 'ChangeLangCtrl',
            },
            'change-email': {
                templatePath: changeEmail,
                controller: 'ChangeEmailModal',
            },
            'password-confirmation': {
                templatePath: passwordConfirmation,
                controller: 'PasswordConfirmationModal',
            },
            'delete-account-confirmation': {
                templatePath: deleteAccountConfirmation,
                controller: 'DeleteAccountConfirmation',
            },
            'get-report': {
                templatePath: getReport,
                controller: 'GetReport',
            },
            'welcome-modal': {
                templatePath: welcomeModalTemplate,
                controller: 'WelcomeModal',
            },
            'welcome-modal-spotlight': {
                templatePath: welcomeModalSpotlightTemplate,
                controller: 'WelcomeModalSpotlight',
            },
            'language-switcher': {
                templatePath: languageSwitcher,
                controller: 'LanguageSwitcherCtrl',
            },
            'ocp-comparison': {
                templatePath: ocpComparisonTemplate,
                controller: 'OcpComparison',
            },
            'add-payment': {
                templatePath: addPaymentTemplate,
                controller: 'AddPayment',
            },
            'payment-cart': {
                templatePath: paymentCartTemplate,
                controller: 'PaymentCart',
            },
            trial: {
                templatePath: trialCard,
                controller: 'TrialCard',
            },
            'gdpr-report': {
                templatePath: gdprReportTemplate,
                controller: 'GdprReport',
            },
            'confirm-login': {
                templatePath: confirmLogin,
                controller: 'ConfirmLogin',
            },
            'threats-landscape': {
                templatePath: threatsLandscape,
                controller: 'ThreatsLandscape',
            },
            'coinbase-account': {
                templatePath: coinbaseAccount,
                controller: 'CoinbaseAccount',
            },
            // DWM
            bankAccounts: {
                templatePath: dwmBankAccounts,
                controller: 'DwmBankAccounts',
            },
            creditDebitCards: {
                templatePath: dwmCreditCards,
                controller: 'DwmCreditCards',
            },
            addresses: {
                templatePath: dwmAddresses,
                controller: 'DwmAddresses',
            },
            phoneNumbers: {
                templatePath: dwmPhoneNumbers,
                controller: 'DwmPhoneNumbers',
            },
            emails: {
                templatePath: dwmEmails,
                controller: 'DwmEmails',
            },
            mothersMaidenName: {
                templatePath: dwmMothersName,
                controller: 'DwmMothersName',
            },
            driversLicense: {
                templatePath: dwmDriversLicense,
                controller: 'DwmDriversLicense',
            },
            insuranceCards: {
                templatePath: dwmInsuranceCards,
                controller: 'DwmInsuranceCards',
            },
            gamerTags: {
                templatePath: dwmGamerTags,
                controller: 'DwmGamerTags',
            },
            notifications: {
                templatePath: dwmNotifications,
                controller: 'DwmNotifications',
            },
            dwmUpsell: {
                templatePath: dwmUpsell,
                controller: 'DwmUpsell',
            },
            'toggle-monitoring': {
                templatePath: dwmToggleMonitoring,
                controller: 'DwmToggleMonitoring',
            },
            'trial-modal': {
                templatePath: trialModalTemplate,
                controller: 'TrialModal',
            },
        }

    ));

angular.module('modals')
    .openModal = (
        $rootScope, $state, $stateParams, $controller, $modal,
        Templates, Modals, $timeout,
    ) => {

        const { ltb } = $stateParams;
        let scope;
        let modal;

        if (_.keys(Modals).indexOf(ltb) >= 0) {

            modal = _.extend({}, Modals[ltb]);
            scope = $rootScope.$new(true);
            scope.template = modal.templatePath;
            scope.modalController = $controller('BaseModal', { $scope: scope });

            modal.template = require('../../views/modals/base.html');
            modal.scope = scope;

            $stateParams.modal = $modal.open(modal);
            $rootScope.State.hasModal = true;

            $stateParams.modal.result.then(() => { }, () => {

                $state.go($state.current.name.split('.').slice(0, -1).join('.'));

            });

            // send an open modal event on open
            eventManager.broadcast('modal:open', {
                modal: $stateParams.ltb,
                service: $stateParams.service,
            });

        } else {

            // we use a timeout to ensure the function is executed in the next tick
            $timeout(() => {

                $state.go('root.dashboard.home');

            }, 0);

        }

    };

angular.module('modals')
    .openModal.$inject = ['$rootScope', '$state', '$stateParams', '$controller',
        '$modal', 'Templates', 'Modals', '$timeout'];

angular.module('modals')
    .closeModal = ($rootScope, $timeout, $state, $stateParams) => {

        if ($stateParams.modal) {

            $stateParams.modal.close();

            $timeout(() => {

                $rootScope.State.hasModal = false;

            }, 0);

        }

        // send a close modal event on close
        eventManager.broadcast('modal:close', {
            modal: $stateParams.ltb,
            service: $stateParams.service,
        });

    };

angular.module('modals')
    .closeModal.$inject = ['$rootScope', '$timeout', '$state', '$stateParams'];

angular.module('modals')
    .service('ModalFix', ($rootScope, $timeout, $window) => {

        const repaintTimeout = 500;
        // Due to a bug in webkit browsers, the backdrop may not be painted
        // from time to time. Force a repaint
        eventManager.subscribe('modal:open', () => {

            Timers.timeouts.push($timeout(() => {

                if ($window.document.querySelector) {

                    const modal = $window.document.querySelector('.modal-backdrop');

                    if (modal) {

                        modal.style.display = 'none';
                        // modal.offsetHeight;
                        modal.style.display = 'block';

                    }

                }

            }, repaintTimeout));

        });

    });



// WEBPACK FOOTER //
// ./scripts/modules/modals.js